module.exports = __webpack_public_path__ + "img/nuestros-servicios_3-pasos-02plan.f5743fc2.svg";